import styled from 'styled-components';

export const Wrapper = styled.div`
`;

export const Header = styled.div`
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  display: flex;
`;

export const TextContainer = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  align-items: center ;
`

export const CardsContainer = styled.div`
  margin-top: 8rem;
`;

export const CardWrapper = styled.div``;

export const ImagesSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;